








































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  collapsed: boolean = false;

  get userName() {
    return this.$store.state.userStore.name
  }

  get isLogin() {
    return this.$store.state.isLogin
  }

  get role() {
    return this.$store.state.userStore.role
  }

  get current() {
    const current = this.$store.state.currentPage
    if (current) {
      return [current]
    }
    else {
      return ['Record']
    }
  }

  logout() {
    this.$store.dispatch('logout')
  }

}
